import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=efc0978a&"
import script from "./ProductItem.ts?vue&type=script&lang=ts&"
export * from "./ProductItem.ts?vue&type=script&lang=ts&"
import style0 from "./ProductItem.style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports